export const localeManualOverrides: Record<string, Record<string, string>> = {
  'en-AU': {
    'xmedia.upload.speed': 'Speed',
    'xmedia.upload.remaining': 'Time remaining'
  },
  'en-GB': {
    'xmedia.upload.speed': 'Speed',
    'xmedia.upload.remaining': 'Time remaining'
  },
  fr: {
    'common.backToLogin': 'Retour a la connexion',
    'common.signIn': 'Se connecter',
    'login.title': 'Bon retour',
    'navbar.dashboard': 'Tableau de bord',
    'navbar.logout': 'Se deconnecter',
    'home.likesTitle': "J'aime",
    'home.dislikesTitle': "Je n'aime pas",
    'home.files': 'fichier',
    'createXperience.submit': "Creer l'experience",
    'xperienceDetail.wait': 'Attendre',
    'xmedia.back': 'Retour',
    'xmedia.saving': 'Enregistrement...',
    'xmedia.field.type': 'Type',
    'xmedia.error.uploadTooLarge': 'Le fichier media est trop volumineux pour la limite actuelle de televersement.',
    'xmedia.upload.selected': 'Selectionne',
    'xmedia.upload.keepOpen': 'Gardez cet onglet du navigateur ouvert jusqu a la fin du televersement.',
    'xmedia.upload.poster': 'Televersement du poster',
    'xmedia.upload.media': 'Televersement du media',
    'xmedia.upload.speed': 'Vitesse',
    'xmedia.upload.remaining': 'Temps restant',
    'xmedia.upload.phase.idle': 'Pret a televerser',
    'xmedia.upload.phase.metadata': 'Enregistrement des metadonnees du media...',
    'xmedia.upload.phase.poster': 'Televersement du poster...',
    'xmedia.upload.phase.media': 'Televersement du media immersif...',
    'xmedia.upload.phase.finalizing': 'Finalisation du televersement...',
    'adminCreatorDetail.back': 'Retour',
    'adminCreatorDetail.saving': 'Enregistrement...',
    'moderation.back': 'Retour',
    'moderation.na': 'N/A',
    'adminXperiences.na': 'N/A',
    'xperienceDetail.noDate': 'N/A',
    'xperienceDetail.mediaCard.na': 'N/A',
    'xmedia.title.edit': 'Modifier le media Xperience',
    'navbar.events': 'Evenements',
    'events.title': 'Evenements',
    'events.subtitle': 'Regroupez des Xperiences dans des livraisons privees pour mariages, evenements d entreprise, baptemes et productions immersives.',
    'events.newEvent': '+ Nouvel evenement',
    'events.loading': 'Chargement des evenements...',
    'events.emptyTitle': 'Aucun evenement pour le moment',
    'events.emptyText': 'Creez un evenement prive et ajoutez les Xperiences a livrer ensemble.',
    'events.createTitle': 'Creer un evenement',
    'events.editTitle': 'Modifier l evenement',
    'events.error.load': 'Impossible de charger les evenements',
    'events.error.save': 'Impossible d enregistrer l evenement',
    'events.error.delete': 'Impossible de supprimer l evenement',
    'events.confirmDelete': 'Supprimer cet evenement ?',
    'events.public': 'Public',
    'events.private': 'Prive',
    'events.xperiences': 'xperiences',
    'events.mediaItems': 'elements media',
    'events.edit': 'Modifier',
    'events.delete': 'Supprimer',
    'events.password': 'Mot de passe',
    'events.saving': 'Enregistrement...',
    'events.save': 'Enregistrer l evenement',
    'events.reset': 'Nouvel evenement',
    'events.privateToggle': 'Evenement prive avec acces par mot de passe',
    'events.field.title': 'Titre',
    'events.field.description': 'Description',
    'events.field.type': 'Type d evenement',
    'events.field.date': 'Date de l evenement',
    'events.field.locationName': 'Nom du lieu',
    'events.field.location': 'Lieu',
    'events.field.coverUrl': 'Chemin de l image de couverture',
    'events.field.password': 'Mot de passe d acces',
    'events.field.xperiences': 'Xperiences incluses',
    'events.reorderXperience': 'Faire glisser pour reordonner',
    'events.placeholder.password': 'Laisser vide pour generation automatique',
    'events.type.wedding': 'Mariage',
    'events.type.baptism': 'Bapteme',
    'events.type.corporate': 'Evenement d entreprise',
    'events.type.privateEvent': 'Evenement prive'
  },
  'fr-CA': {
    'common.backToLogin': 'Retour a la connexion',
    'common.signIn': 'Se connecter',
    'login.title': 'Bon retour',
    'navbar.dashboard': 'Tableau de bord',
    'navbar.logout': 'Se deconnecter',
    'home.likesTitle': "J'aime",
    'home.dislikesTitle': "Je n'aime pas",
    'home.files': 'fichier',
    'createXperience.submit': "Creer l'experience",
    'xperienceDetail.wait': 'Attendre',
    'xmedia.back': 'Retour',
    'xmedia.saving': 'Enregistrement...',
    'xmedia.field.type': 'Type',
    'xmedia.error.uploadTooLarge': 'Le fichier media est trop volumineux pour la limite actuelle de televersement.',
    'xmedia.upload.selected': 'Selectionne',
    'xmedia.upload.keepOpen': 'Gardez cet onglet du navigateur ouvert jusqu a la fin du televersement.',
    'xmedia.upload.poster': 'Televersement du poster',
    'xmedia.upload.media': 'Televersement du media',
    'xmedia.upload.speed': 'Vitesse',
    'xmedia.upload.remaining': 'Temps restant',
    'xmedia.upload.phase.idle': 'Pret a televerser',
    'xmedia.upload.phase.metadata': 'Enregistrement des metadonnees du media...',
    'xmedia.upload.phase.poster': 'Televersement du poster...',
    'xmedia.upload.phase.media': 'Televersement du media immersif...',
    'xmedia.upload.phase.finalizing': 'Finalisation du televersement...',
    'adminCreatorDetail.back': 'Retour',
    'adminCreatorDetail.saving': 'Enregistrement...',
    'moderation.back': 'Retour',
    'moderation.na': 'N/A',
    'adminXperiences.na': 'N/A',
    'xperienceDetail.noDate': 'N/A',
    'xperienceDetail.mediaCard.na': 'N/A',
    'xmedia.title.edit': 'Modifier le media Xperience',
    'navbar.events': 'Evenements',
    'events.title': 'Evenements',
    'events.subtitle': 'Regroupez des Xperiences dans des livraisons privees pour mariages, evenements d entreprise, baptemes et productions immersives.',
    'events.newEvent': '+ Nouvel evenement',
    'events.loading': 'Chargement des evenements...',
    'events.emptyTitle': 'Aucun evenement pour le moment',
    'events.emptyText': 'Creez un evenement prive et ajoutez les Xperiences a livrer ensemble.',
    'events.createTitle': 'Creer un evenement',
    'events.editTitle': 'Modifier l evenement',
    'events.error.load': 'Impossible de charger les evenements',
    'events.error.save': 'Impossible d enregistrer l evenement',
    'events.error.delete': 'Impossible de supprimer l evenement',
    'events.confirmDelete': 'Supprimer cet evenement ?',
    'events.public': 'Public',
    'events.private': 'Prive',
    'events.xperiences': 'xperiences',
    'events.mediaItems': 'elements media',
    'events.edit': 'Modifier',
    'events.delete': 'Supprimer',
    'events.password': 'Mot de passe',
    'events.saving': 'Enregistrement...',
    'events.save': 'Enregistrer l evenement',
    'events.reset': 'Nouvel evenement',
    'events.privateToggle': 'Evenement prive avec acces par mot de passe',
    'events.field.title': 'Titre',
    'events.field.description': 'Description',
    'events.field.type': 'Type d evenement',
    'events.field.date': 'Date de l evenement',
    'events.field.locationName': 'Nom du lieu',
    'events.field.location': 'Lieu',
    'events.field.coverUrl': 'Chemin de l image de couverture',
    'events.field.password': 'Mot de passe d acces',
    'events.field.xperiences': 'Xperiences incluses',
    'events.reorderXperience': 'Faire glisser pour reordonner',
    'events.placeholder.password': 'Laisser vide pour generation automatique',
    'events.type.wedding': 'Mariage',
    'events.type.baptism': 'Bapteme',
    'events.type.corporate': 'Evenement d entreprise',
    'events.type.privateEvent': 'Evenement prive'
  },
  de: {
    'common.signIn': 'Anmelden',
    'navbar.dashboard': 'Dashboard',
    'navbar.modXperiences': 'Mod. Xperiences',
    'navbar.generating': 'Wird erstellt...',
    'home.likesTitle': 'Likes',
    'home.dislikesTitle': 'Dislikes',
    'home.files': 'Datei',
    'home.filesPlural': 'Dateien',
    'beCreator.ctaSecondary': 'Ich habe bereits ein Konto',
    'createXperience.submit': 'Xperience erstellen',
    'xperienceDetail.wait': 'Warten',
    'xmedia.back': 'Zuruck',
    'xmedia.saving': 'Speichern...',
    'xmedia.field.type': 'Typ',
    'xmedia.error.uploadTooLarge': 'Die Mediendatei ist zu gross fuer das aktuelle Upload-Limit.',
    'xmedia.upload.selected': 'Ausgewaehlt',
    'xmedia.upload.keepOpen': 'Lassen Sie diesen Browser-Tab geoeffnet, bis der Upload abgeschlossen ist.',
    'xmedia.upload.poster': 'Poster-Upload',
    'xmedia.upload.media': 'Medien-Upload',
    'xmedia.upload.speed': 'Geschwindigkeit',
    'xmedia.upload.remaining': 'Verbleibende Zeit',
    'xmedia.upload.phase.idle': 'Bereit zum Upload',
    'xmedia.upload.phase.metadata': 'Medienmetadaten werden gespeichert...',
    'xmedia.upload.phase.poster': 'Poster wird hochgeladen...',
    'xmedia.upload.phase.media': 'Immersive Medien werden hochgeladen...',
    'xmedia.upload.phase.finalizing': 'Upload wird abgeschlossen...',
    'adminCreatorDetail.saving': 'Speichern...',
    'moderation.na': 'N/A',
    'adminXperiences.na': 'N/A',
    'xperienceDetail.noDate': 'N/A',
    'xperienceDetail.mediaCard.na': 'N/A',
    'navbar.events': 'Events',
    'events.title': 'Events',
    'events.subtitle': 'Gruppiere Xperiences als private Kundenlieferungen fuer Hochzeiten, Firmenevents, Taufen und immersive Produktionen.',
    'events.newEvent': '+ Neues Event',
    'events.loading': 'Events werden geladen...',
    'events.emptyTitle': 'Noch keine Events',
    'events.emptyText': 'Erstelle ein privates Event und fuege die Xperiences hinzu, die gemeinsam geliefert werden sollen.',
    'events.createTitle': 'Event erstellen',
    'events.editTitle': 'Event bearbeiten',
    'events.error.load': 'Events konnten nicht geladen werden',
    'events.error.save': 'Event konnte nicht gespeichert werden',
    'events.error.delete': 'Event konnte nicht geloescht werden',
    'events.confirmDelete': 'Dieses Event loeschen?',
    'events.public': 'Oeffentlich',
    'events.private': 'Privat',
    'events.xperiences': 'xperiences',
    'events.mediaItems': 'Medienelemente',
    'events.edit': 'Bearbeiten',
    'events.delete': 'Loeschen',
    'events.password': 'Passwort',
    'events.saving': 'Speichern...',
    'events.save': 'Event speichern',
    'events.reset': 'Neues Event',
    'events.privateToggle': 'Privates Event mit Passwortzugriff',
    'events.field.title': 'Titel',
    'events.field.description': 'Beschreibung',
    'events.field.type': 'Eventtyp',
    'events.field.date': 'Eventdatum',
    'events.field.locationName': 'Ortsname',
    'events.field.location': 'Ort',
    'events.field.coverUrl': 'Pfad zum Titelbild',
    'events.field.password': 'Zugriffspasswort',
    'events.field.xperiences': 'Enthaltene Xperiences',
    'events.reorderXperience': 'Zum Neuordnen ziehen',
    'events.placeholder.password': 'Leer lassen fuer automatische Generierung',
    'events.type.wedding': 'Hochzeit',
    'events.type.baptism': 'Taufe',
    'events.type.corporate': 'Firmenevent',
    'events.type.privateEvent': 'Privates Event'
  },
  ja: {
    'common.signIn': 'ログイン',
    'navbar.dashboard': 'ダッシュボード',
    'navbar.logout': 'ログアウト',
    'adminCreatorDetail.back': '戻る',
    'moderation.back': '戻る',
    'home.viewDetails': '詳細を見る',
    'createXperience.submit': 'Xperienceを作成',
    'xmedia.saving': '保存中...',
    'xmedia.back': '戻る',
    'xmedia.error.uploadTooLarge': 'メディアファイルが現在のアップロード上限を超えています。',
    'xmedia.upload.selected': '選択済み',
    'xmedia.upload.keepOpen': 'アップロードが完了するまで、このブラウザタブを開いたままにしてください。',
    'xmedia.upload.poster': 'ポスターのアップロード',
    'xmedia.upload.media': 'メディアのアップロード',
    'xmedia.upload.speed': '速度',
    'xmedia.upload.remaining': '残り時間',
    'xmedia.upload.phase.idle': 'アップロード準備完了',
    'xmedia.upload.phase.metadata': 'メディアのメタデータを保存中...',
    'xmedia.upload.phase.poster': 'ポスターをアップロード中...',
    'xmedia.upload.phase.media': '没入型メディアをアップロード中...',
    'xmedia.upload.phase.finalizing': 'アップロードを完了中...',
    'navbar.events': 'イベント',
    'events.title': 'イベント',
    'events.subtitle': '結婚式、企業イベント、洗礼式、没入型制作のために、Xperiencesをプライベートな納品としてまとめます。',
    'events.newEvent': '+ 新規イベント',
    'events.loading': 'イベントを読み込み中...',
    'events.emptyTitle': 'イベントはまだありません',
    'events.emptyText': 'プライベートイベントを作成し、一緒に納品するXperiencesを追加してください。',
    'events.createTitle': 'イベントを作成',
    'events.editTitle': 'イベントを編集',
    'events.error.load': 'イベントを読み込めませんでした',
    'events.error.save': 'イベントを保存できませんでした',
    'events.error.delete': 'イベントを削除できませんでした',
    'events.confirmDelete': 'このイベントを削除しますか？',
    'events.public': '公開',
    'events.private': 'プライベート',
    'events.xperiences': 'xperiences',
    'events.mediaItems': 'メディア項目',
    'events.edit': '編集',
    'events.delete': '削除',
    'events.password': 'パスワード',
    'events.saving': '保存中...',
    'events.save': 'イベントを保存',
    'events.reset': '新規イベント',
    'events.privateToggle': 'パスワードアクセス付きプライベートイベント',
    'events.field.title': 'タイトル',
    'events.field.description': '説明',
    'events.field.type': 'イベント種別',
    'events.field.date': 'イベント日',
    'events.field.locationName': '場所名',
    'events.field.location': '場所',
    'events.field.coverUrl': 'カバー画像パス',
    'events.field.password': 'アクセスパスワード',
    'events.field.xperiences': '含まれるXperiences',
    'events.reorderXperience': 'ドラッグして並べ替え',
    'events.placeholder.password': '空欄なら自動生成',
    'events.type.wedding': '結婚式',
    'events.type.baptism': '洗礼式',
    'events.type.corporate': '企業イベント',
    'events.type.privateEvent': 'プライベートイベント'
  },
  'zh-Hans': {
    'common.signIn': '登录',
    'navbar.dashboard': '仪表板',
    'navbar.logout': '退出登录',
    'adminCreatorDetail.back': '返回',
    'moderation.back': '返回',
    'home.viewDetails': '查看详情',
    'createXperience.submit': '创建 Xperience',
    'xmedia.saving': '保存中...',
    'xmedia.back': '返回',
    'xmedia.error.uploadTooLarge': '媒体文件超过当前上传限制。',
    'xmedia.upload.selected': '已选择',
    'xmedia.upload.keepOpen': '上传完成前请保持此浏览器标签页打开。',
    'xmedia.upload.poster': '封面上传',
    'xmedia.upload.media': '媒体上传',
    'xmedia.upload.speed': '速度',
    'xmedia.upload.remaining': '剩余时间',
    'xmedia.upload.phase.idle': '准备上传',
    'xmedia.upload.phase.metadata': '正在保存媒体元数据...',
    'xmedia.upload.phase.poster': '正在上传封面...',
    'xmedia.upload.phase.media': '正在上传沉浸式媒体...',
    'xmedia.upload.phase.finalizing': '正在完成上传...',
    'navbar.events': '活动',
    'events.title': '活动',
    'events.subtitle': '将 Xperiences 组合成婚礼、企业活动、洗礼和沉浸式制作的私密客户交付。',
    'events.newEvent': '+ 新建活动',
    'events.loading': '正在加载活动...',
    'events.emptyTitle': '暂无活动',
    'events.emptyText': '创建一个私密活动，并添加要一起交付的 Xperiences。',
    'events.createTitle': '创建活动',
    'events.editTitle': '编辑活动',
    'events.error.load': '无法加载活动',
    'events.error.save': '无法保存活动',
    'events.error.delete': '无法删除活动',
    'events.confirmDelete': '删除此活动？',
    'events.public': '公开',
    'events.private': '私密',
    'events.xperiences': 'xperiences',
    'events.mediaItems': '媒体项目',
    'events.edit': '编辑',
    'events.delete': '删除',
    'events.password': '密码',
    'events.saving': '正在保存...',
    'events.save': '保存活动',
    'events.reset': '新建活动',
    'events.privateToggle': '使用密码访问的私密活动',
    'events.field.title': '标题',
    'events.field.description': '描述',
    'events.field.type': '活动类型',
    'events.field.date': '活动日期',
    'events.field.locationName': '地点名称',
    'events.field.location': '地点',
    'events.field.coverUrl': '封面图片路径',
    'events.field.password': '访问密码',
    'events.field.xperiences': '包含的 Xperiences',
    'events.reorderXperience': '拖动以重新排序',
    'events.placeholder.password': '留空则自动生成',
    'events.type.wedding': '婚礼',
    'events.type.baptism': '洗礼',
    'events.type.corporate': '企业活动',
    'events.type.privateEvent': '私密活动'
  },
  'zh-Hant': {
    'common.signIn': '登入',
    'navbar.dashboard': '儀表板',
    'navbar.logout': '登出',
    'adminCreatorDetail.back': '返回',
    'moderation.back': '返回',
    'home.viewDetails': '查看詳情',
    'createXperience.submit': '建立 Xperience',
    'xmedia.saving': '儲存中...',
    'xmedia.back': '返回',
    'xmedia.error.uploadTooLarge': '媒體檔案超過目前上傳限制。',
    'xmedia.upload.selected': '已選取',
    'xmedia.upload.keepOpen': '上傳完成前請保持此瀏覽器分頁開啟。',
    'xmedia.upload.poster': '封面上傳',
    'xmedia.upload.media': '媒體上傳',
    'xmedia.upload.speed': '速度',
    'xmedia.upload.remaining': '剩餘時間',
    'xmedia.upload.phase.idle': '準備上傳',
    'xmedia.upload.phase.metadata': '正在儲存媒體中繼資料...',
    'xmedia.upload.phase.poster': '正在上傳封面...',
    'xmedia.upload.phase.media': '正在上傳沉浸式媒體...',
    'xmedia.upload.phase.finalizing': '正在完成上傳...',
    'navbar.events': '活動',
    'events.title': '活動',
    'events.subtitle': '將 Xperiences 組合成婚禮、企業活動、洗禮和沉浸式製作的私人客戶交付。',
    'events.newEvent': '+ 建立活動',
    'events.loading': '正在載入活動...',
    'events.emptyTitle': '尚無活動',
    'events.emptyText': '建立私人活動，並加入要一起交付的 Xperiences。',
    'events.createTitle': '建立活動',
    'events.editTitle': '編輯活動',
    'events.error.load': '無法載入活動',
    'events.error.save': '無法儲存活動',
    'events.error.delete': '無法刪除活動',
    'events.confirmDelete': '刪除此活動？',
    'events.public': '公開',
    'events.private': '私人',
    'events.xperiences': 'xperiences',
    'events.mediaItems': '媒體項目',
    'events.edit': '編輯',
    'events.delete': '刪除',
    'events.password': '密碼',
    'events.saving': '正在儲存...',
    'events.save': '儲存活動',
    'events.reset': '建立活動',
    'events.privateToggle': '使用密碼存取的私人活動',
    'events.field.title': '標題',
    'events.field.description': '描述',
    'events.field.type': '活動類型',
    'events.field.date': '活動日期',
    'events.field.locationName': '地點名稱',
    'events.field.location': '地點',
    'events.field.coverUrl': '封面圖片路徑',
    'events.field.password': '存取密碼',
    'events.field.xperiences': '包含的 Xperiences',
    'events.reorderXperience': '拖曳以重新排序',
    'events.placeholder.password': '留空則自動產生',
    'events.type.wedding': '婚禮',
    'events.type.baptism': '洗禮',
    'events.type.corporate': '企業活動',
    'events.type.privateEvent': '私人活動',
    'events.privateQR.alt': '私人活動存取二維碼'
  },
  'zh-HK': {
    'common.signIn': '登入',
    'navbar.dashboard': '儀表板',
    'navbar.logout': '登出',
    'adminCreatorDetail.back': '返回',
    'moderation.back': '返回',
    'home.viewDetails': '查看詳情',
    'createXperience.submit': '建立 Xperience',
    'xmedia.saving': '儲存中...',
    'xmedia.back': '返回',
    'xmedia.error.uploadTooLarge': '媒體檔案超過目前上載限制。',
    'xmedia.upload.selected': '已選取',
    'xmedia.upload.keepOpen': '上載完成前請保持此瀏覽器分頁開啟。',
    'xmedia.upload.poster': '封面上載',
    'xmedia.upload.media': '媒體上載',
    'xmedia.upload.speed': '速度',
    'xmedia.upload.remaining': '剩餘時間',
    'xmedia.upload.phase.idle': '準備上載',
    'xmedia.upload.phase.metadata': '正在儲存媒體中繼資料...',
    'xmedia.upload.phase.poster': '正在上載封面...',
    'xmedia.upload.phase.media': '正在上載沉浸式媒體...',
    'xmedia.upload.phase.finalizing': '正在完成上載...',
    'navbar.events': '活動',
    'events.title': '活動',
    'events.subtitle': '將 Xperiences 組合成婚禮、企業活動、洗禮同沉浸式製作嘅私人客戶交付。',
    'events.newEvent': '+ 建立活動',
    'events.loading': '正在載入活動...',
    'events.emptyTitle': '尚無活動',
    'events.emptyText': '建立私人活動，並加入要一齊交付嘅 Xperiences。',
    'events.createTitle': '建立活動',
    'events.editTitle': '編輯活動',
    'events.error.load': '無法載入活動',
    'events.error.save': '無法儲存活動',
    'events.error.delete': '無法刪除活動',
    'events.confirmDelete': '刪除此活動？',
    'events.public': '公開',
    'events.private': '私人',
    'events.xperiences': 'xperiences',
    'events.mediaItems': '媒體項目',
    'events.edit': '編輯',
    'events.delete': '刪除',
    'events.password': '密碼',
    'events.saving': '正在儲存...',
    'events.save': '儲存活動',
    'events.reset': '建立活動',
    'events.privateToggle': '使用密碼存取嘅私人活動',
    'events.field.title': '標題',
    'events.field.description': '描述',
    'events.field.type': '活動類型',
    'events.field.date': '活動日期',
    'events.field.locationName': '地點名稱',
    'events.field.location': '地點',
    'events.field.coverUrl': '封面圖片路徑',
    'events.field.password': '存取密碼',
    'events.field.xperiences': '包含嘅 Xperiences',
    'events.reorderXperience': '拖曳以重新排序',
    'events.placeholder.password': '留空則自動產生',
    'events.type.wedding': '婚禮',
    'events.type.baptism': '洗禮',
    'events.type.corporate': '企業活動',
    'events.type.privateEvent': '私人活動',
    'events.privateQR.alt': '私人活動存取二維碼'
  }
};
